import { render } from "./LandingItem.vue?vue&type=template&id=e62fb00c&scoped=true"
import script from "./LandingItem.vue?vue&type=script&lang=js"
export * from "./LandingItem.vue?vue&type=script&lang=js"

import "./LandingItem.vue?vue&type=style&index=0&id=e62fb00c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e62fb00c"]])

export default __exports__